import { Observable, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { GeneratorEnv } from '../../generator-env-token';
import * as i0 from "@angular/core";
import * as i1 from "../../generator-env-token";
import * as i2 from "../../../share/service/common-http-client.service";
export class CmsService {
    constructor(generatorEnv, http) {
        this.generatorEnv = generatorEnv;
        this.http = http;
    }
    get(cmsType, params) {
        return this.http.get(`${this.generatorEnv.apiHost}/api/cms/${cmsType}`, { params });
    }
    getDetail(cmsType, id) {
        return this.http.get(`${this.generatorEnv.apiHost}/api/cms/${cmsType}/${id}`);
    }
    getNormalDetail(lang, cmsType, id) {
        return this.http.get(`${this.generatorEnv.apiHost}/api/${lang}/cm/normal/${cmsType}/${id}`);
    }
    getMenuSetting(cmsType) {
        return timer(0, 0).pipe(take(1));
        // TODO 沒有menuSetting
        return this.http.get(`${this.generatorEnv.apiHost}/api/cms/menuSetting/${cmsType}`);
    }
    resolveCmsType(lang, cmsType) {
        return this.http.get(`${this.generatorEnv.apiHost}/api/site/${lang}/menu/${cmsType}`);
    }
}
CmsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CmsService_Factory() { return new CmsService(i0.ɵɵinject(i1.GENERATOR_ENV_TOKEN), i0.ɵɵinject(i2.CommonHttpClientService)); }, token: CmsService, providedIn: "root" });
